export default {
  header: 'Štítky udalostí',
  empty: 'Zatiaľ neboli vytvorené žiadne štítky udalostí.',
  confirmDelete: 'Naozaj chcete odstrániť "{item}"? Udalosti, ktoré tento štítok už majú, si ho ponechajú.',
};
